'use client';

import React, { Fragment } from 'react';
import { useAppSelector, useAppStore } from '@/lib/frontend/store/hooks';
import { HeaderLink } from './header-link';
import { selectSessionUser } from '@/lib/frontend/store/helpers';
import SignOut from '@/lib/frontend/store/actionCreators/SignOut';

const HeaderSignIn = () => {
  const user = useAppSelector(selectSessionUser);
  const store = useAppStore();

  if (user) {
    return (
      <Fragment>
        <li>
          <HeaderLink label="Account" href="/account" />
        </li>
        <li>
          <button
            onClick={() => {
              SignOut(store);
            }}
          >
            <HeaderLink label="Sign Out" aria-label="Sign Out" href="#" />
          </button>
        </li>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <li>
        <HeaderLink label="Sign In" href="/account" />
      </li>
    </Fragment>
  );
};

export default HeaderSignIn;
